import {useTranslation} from "react-i18next";
import OrderDashboardLayout from "./Layout/OrderDashboardLayout.jsx";
import PnoInTimeGraph from "./TablesAndGraphs/ByFilter/PnoInTimeGraph.jsx";
import OrdersInTimeGraph from "./TablesAndGraphs/ByFilter/OrdersInTimeGraph.jsx";
import React, {useContext, useEffect, useState} from "react";
import ClicksInTimeGraph from "./TablesAndGraphs/ByFilter/ClicksInTimeGraph.jsx";
import CpcInTimeGraph from "./TablesAndGraphs/ByFilter/CpcInTimeGraph.jsx";
import {FilterContext} from "../../../components/filters/DashboardFilterContextProvider.jsx";
import {ErpCalculationApi} from "../../../api/authority/generated/index";
import useAuthorityConfiguration from "../../../api/utilities/useAuthorityConfiguration.js";
import {useErrorTranslation} from "../../../api/utilities/translateErrorMessage.js";
import toast from "react-hot-toast";
import {SnapshotCompletenessNotice} from "../../admin/ReportingLab.jsx";

export default function CampaignPerformance({project}) {

    let {t} = useTranslation();
    let {et} = useErrorTranslation();
    let authorityConfiguration = useAuthorityConfiguration();
    let {since, until, centresAllowListed, domainsAllowListed} = useContext(FilterContext);
    let sinceKey = since.format('YYYY-MM-DD');
    let untilKey = until.format('YYYY-MM-DD');
    let [data, setData] = useState(null);

    useEffect(() => {
        let active = true;
        setData(null);

        new ErpCalculationApi(authorityConfiguration)
            .reportingMarketingTrends({
                projectId: project.id,
                erpFilter: {
                    since: sinceKey,
                    until: untilKey,
                    selectedCentreIds: centresAllowListed ?? [],
                    selectedDomainIds: domainsAllowListed ?? [],
                },
            })
            .then((nextData) => {
                if (active) {
                    setData(nextData);
                }
            })
            .catch((e) => {
                if (active) {
                    et(e).then((message) => { if (message) toast.error(message); });
                }
            });

        return () => {
            active = false;
        };
    }, [project.id, sinceKey, untilKey, centresAllowListed, domainsAllowListed]);

    // noinspection JSValidateTypes
    return <OrderDashboardLayout title={t('route.campaign-comparison')} showMarketingFilters={true}>
        <SnapshotCompletenessNotice snapshots={data?.snapshot} className="col-span-12"/>
        <PnoInTimeGraph project={project} fullWidth={true} showLegend={false} data={data?.pno ?? null}/>
        <OrdersInTimeGraph project={project} fullWidth={true} showLegend={false} data={data?.orders ?? null}/>
        <ClicksInTimeGraph project={project} fullWidth={true} showLegend={false} data={data?.clicks ?? null}/>
        <CpcInTimeGraph project={project} fullWidth={true} showLegend={false} data={data?.cpc ?? null}/>
    </OrderDashboardLayout>;
}
